/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Define all the calender showing event types
 */
const EVENT_TYPES = {
  ANNUAL_SPORTS_EVENT: 'Special / Annual sports event',
  WEATHER_FORECASTABLE: 'Weather (forecastable)',
  WEATHER_NON_FORECASTABLE: 'Weather / Natural Disaster (non-forecastable)',
  US_HOLIDAY: 'US Holiday',
  US_LONG_WEEKEND: 'US Long Weekend',
  FESTIVAL: 'Festivals',
  ENTERTAINMENT: 'Entertainment',
  CITY_WIDE_CONFERENCE: 'City Wide Conferences (with rooms)',
  CONFERENCE_AND_SHOWS: 'Conferences & Shows (no rooms)',
  HOTEL_GROUP_BOOKINGS: 'Hotel Group Bookings',
  OTHER: 'Other',
  REGULAR_SPORTS_EVENT: 'Regular Sports Event',
};
//
export default EVENT_TYPES;
